var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretRight = function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.6 1.399C.6 1.164.691.945.856.78L1.38.256A.87.87 0 0 1 2 0c.234 0 .453.09.618.256l7.127 7.126a.87.87 0 0 1 .255.621c0 .236-.09.456-.255.622l-7.12 7.12a.87.87 0 0 1-.62.255.87.87 0 0 1-.618-.256l-.525-.524a.876.876 0 0 1 0-1.238l5.98-5.979L.855 2.018a.87.87 0 0 1-.256-.62"
  })));
};
export default SvgCaretRight;